import React from 'react';
import { Select, Input, Tag } from 'antd';

/**
 * Mapping 表 Value 欄共用組件，依 sourceType 切換內容：
 *  - eFormField     → Select，options 為上游 sendEForm 節點的欄位（map: { name, label }）
 *  - datasetColumn  → Select，options 為上游 dataSetQuery 節點的 mappedFields[].fieldName
 *  - variable / processVariable → Select，options 為流程變數
 *  - static         → Input
 *  - expr (legacy)  → Input + warning tag（已棄用）
 *
 * Props：
 *  - sourceType
 *  - value
 *  - onChange(v)
 *  - eFormFields   : Array<{ name, label, type }>
 *  - datasetColumns: Array<string>
 *  - processVariables: Array<{ id, variableName }>
 *  - t
 */
const OdooSourceValueSelect = ({
  sourceType,
  value,
  onChange,
  eFormFields = [],
  datasetColumns = [],
  processVariables = [],
  t
}) => {
  const tt = (k, fb) => (typeof t === 'function' ? (t(k) || fb) : fb);
  const st = (sourceType || '').toLowerCase();

  if (st === 'eformfield') {
    return (
      <Select
        showSearch
        allowClear
        style={{ width: '100%' }}
        value={value || undefined}
        onChange={(v) => onChange(v || '')}
        placeholder={tt('workflowDesigner.odoo.sourceEFormFieldPlaceholder', '選 eForm 欄位…')}
        filterOption={(input, opt) =>
          (opt?.value || '').toLowerCase().includes(input.toLowerCase()) ||
          (opt?.label || '').toLowerCase().includes(input.toLowerCase())
        }
        options={eFormFields.map(f => ({
          value: f.name,
          label: f.label && f.label !== f.name ? `${f.name} — ${f.label}` : f.name
        }))}
      />
    );
  }

  if (st === 'datasetcolumn') {
    return (
      <Select
        showSearch
        allowClear
        style={{ width: '100%' }}
        value={value || undefined}
        onChange={(v) => onChange(v || '')}
        placeholder={tt('workflowDesigner.odoo.sourceDatasetColumnPlaceholder', '選 DataSet 欄…')}
        filterOption={(input, opt) =>
          (opt?.value || '').toLowerCase().includes(input.toLowerCase())
        }
        options={(datasetColumns || []).map(c => ({ value: c, label: c }))}
      />
    );
  }

  if (st === 'variable' || st === 'processvariable') {
    return (
      <Select
        showSearch
        allowClear
        style={{ width: '100%' }}
        value={value || undefined}
        onChange={(v) => onChange(v || '')}
        placeholder={tt('workflowDesigner.odoo.sourceVariablePlaceholder', '選流程變數…')}
        filterOption={(input, opt) =>
          (opt?.value || '').toLowerCase().includes(input.toLowerCase())
        }
        options={processVariables.map(pv => ({ value: pv.variableName, label: pv.variableName }))}
      />
    );
  }

  if (st === 'expr') {
    return (
      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        <Input
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="{{ pv.x | upper }}"
        />
        <Tag color="orange" style={{ marginLeft: 4 }}>
          {tt('workflowDesigner.odoo.expressionDeprecatedTag', '已棄用')}
        </Tag>
      </div>
    );
  }

  // static (default)
  return (
    <Input
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={tt('workflowDesigner.odoo.sourceStaticPlaceholder', '輸入靜態值')}
    />
  );
};

export default OdooSourceValueSelect;
